import { ADD_CONNECTION, APPEND_CONNECTION, REMOVE_CONNECTION, UPDATE_USED_CONNECTION } from '../actionsList';



const initialInfo = {
    connections: []
};
const connectionReducer = (state = initialInfo, action) => {

    switch (action.type) {

        case APPEND_CONNECTION: {
            let connections = state.connections

            if (!connections) {
                connections = []
            }
            console.log('action connection', action.connections)
            action.connections.map((connection) => {
                let found = false
                let cIndex
                connections.map((oneConnection, index) => {
                    if (connection._id == oneConnection._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (!found) {
                    connections.push(connection)
                }
                else {
                    connections[cIndex] = connection
                }
            })
            connections.sort((a, b) => {
                if (!a.rDate && !b.rDate) {
                    return 0; // No rDate value for both objects, consider them equal
                }
                if (!a.rDate) {
                    return 1; // Object a has no rDate, place it after object b
                }
                if (!b.rDate) {
                    return -1; // Object b has no rDate, place it after object a
                }
                return new Date(b.rDate).getTime() - new Date(a.rDate).getTime();
            })
            // console.log(key)
            // console.log(list)

            return {
                ...state,
                connections: connections,
            }

        }
        case ADD_CONNECTION: {
            let connections = []

            // console.log('action connection', action.connections)
            action.connections.map((connection) => {
                let found = false
                let cIndex
                connections.map((oneConnection, index) => {
                    if (connection._id == oneConnection._id) {
                        found = true
                        cIndex = index
                    }
                })
                if (!found) {
                    connections.push(connection)
                }
                else {
                    connections[cIndex] = connection
                }
            })
            connections.sort((a, b) => {
                if (!a.rDate && !b.rDate) {
                    return 0; // No rDate value for both objects, consider them equal
                }
                if (!a.rDate) {
                    return 1; // Object a has no rDate, place it after object b
                }
                if (!b.rDate) {
                    return -1; // Object b has no rDate, place it after object a
                }
                return new Date(b.rDate).getTime() - new Date(a.rDate).getTime();
            })
            // console.log(key)
            // console.log(list)

            return {
                ...state,
                connections: connections,
            }

        }
        case REMOVE_CONNECTION: {
            let connections = state.connections
            if (!connections) {
                connections = []
            }
            let found
            let cIndex
            action.connections.map((connection) => {
                connections.map((oneConnection, index) => {
                    if (connection == (oneConnection.applet?._id ?? oneConnection.applet)) {
                        found = true
                        cIndex = index
                    }
                })
            })
            if (found) {
                connections.splice(cIndex, 1)
            }
        }
        case UPDATE_USED_CONNECTION: {
            let connections = state.connections
            let now = new Date()
            if (!connections) {
                connections = []
            }
            action.connections.map((connection) => {
                connections.map((oneConnection, index) => {
                    if (connection._id == oneConnection._id) {
                        connections[index].rDate = now
                    }
                })
            })
            connections.sort((a, b) => {
                if (!a.rDate && !b.rDate) {
                    return 0;
                }
                if (!a.rDate) {
                    return 1;
                }
                if (!b.rDate) {
                    return -1;
                }
                return new Date(b.rDate).getTime() - new Date(a.rDate).getTime();
            })
            return {
                ...state,
                connections: connections,
            }
        }
        default:
            return state;
    }
}
export default connectionReducer;